import db from '../../firebase/firebaseInit'
import firebase from 'firebase'

export default {
  state: {
    loading: false
  },
  getters: {},
  mutations: {
    toggleLoading (state) {
      state.loading = !state.loading
    }
  },
  actions: {
    uploadFileToStorageAndOpdracht ({ commit }, payload) {
      commit('toggleLoading')
      let uploadData = {
        opdrachtId: payload.opdrachtId,
        fileName: payload.fileName,
        file: payload.file
      }
      firebase
        .storage()
        .ref('opdrachten/' + uploadData.fileName)
        .put(uploadData.file)
        .then(fileData => {
          console.log('File is uploaded!')
          return fileData.ref
            .getDownloadURL()
            .then(fileUrl => {
              const file = {
                name: uploadData.fileName,
                url: fileUrl
              }
              return db
                .collection('opdrachten')
                .doc(uploadData.opdrachtId)
                .update({
                  files: firebase.firestore.FieldValue.arrayUnion(file)
                })
              // .update({
              //   file: fileUrl
              // })
            })
            .then(() => {
              console.log('FileUrl is stored in db!')
              commit('toggleLoading')
            })
        })
        .catch(err => {
          console.log(err)
        })
    },
    deleteFileFromStorageAndOpdracht ({ commit }, payload) {
      commit('toggleLoading')
      const deleteData = {
        opdrachtId: payload.opdrachtId,
        fileUrl: payload.fileUrl,
        fileName: payload.fileName,
        files: payload.files
      }
      firebase
        .storage()
        .ref('opdrachten/' + deleteData.fileName)
        .delete()
        .then(() => {
          console.log('Delete from storage succesfull!')
          return db
            .collection('opdrachten')
            .doc(deleteData.opdrachtId)
            .update({
              files: deleteData.files.filter(
                file => file.url !== deleteData.fileUrl
              )
            })
        })
        .then(() => {
          console.log('Delete from db succesfull!')
          commit('toggleLoading')
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
}
